import { utils ,isIOS } from "./utils.js";
export const dynamicCreateManifest = (res) => {

  // console.log('1111111111111111111111111111 ',res ,terminaltype)
   let terminaltype = isIOS() ?  'shortcut' : 'pwa'
  const {
    desktopIconName,
    desktopBigIcon,
    desktopSmallIcon,
    desktopBackgroundColor,
    desktopThemeColor,
  } = res;

  const dynamicManifest = {
    short_name: desktopIconName,
    name: desktopIconName,
    display: "standalone",
    start_url: window.location.origin + "?terminaltype="+terminaltype,
    background_color: desktopBackgroundColor,
    theme_color: desktopThemeColor,
    icons: [
      {
        src: utils.returnImgUrl(desktopSmallIcon),
        sizes: "192x192",
        type: "image/png",
      },
      {
        src: utils.returnImgUrl(desktopBigIcon),
        sizes: "512x512",
        type: "image/png",
      },
    ],
  };
  const manifestString = JSON.stringify(dynamicManifest);
  const blob = new Blob([manifestString], { type: "application/json" });
  const manifestURL = URL.createObjectURL(blob);
  const linkElement = document.createElement("link");
  linkElement.rel = "manifest";
  linkElement.href = manifestURL;
  document.head.appendChild(linkElement);
};
